import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-result-card-wrapper certification" }
const _hoisted_2 = { class: "search-result-card-section-group left" }
const _hoisted_3 = { class: "group" }
const _hoisted_4 = {
  class: "search-result-card-section",
  id: "borrowername"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  class: "search-result-card-section",
  id: "status"
}
const _hoisted_7 = { class: "xcertificationstatus" }
const _hoisted_8 = { class: "group" }
const _hoisted_9 = {
  class: "search-result-card-section referenceid",
  id: "referenceid"
}
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  class: "search-result-card-section",
  id: "amount"
}
const _hoisted_12 = { class: "search-result-card-section lender" }
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  key: 0,
  class: "search-result-card-section",
  id: "createdatutc"
}
const _hoisted_15 = { style: {"color":"red"} }

import { PropType } from "vue";
import useFunctions from "@/use/functions1";
import { useDebugDateKey } from "@/composables/useDebugDateKey";


export default /*@__PURE__*/_defineComponent({
  __name: 'CertificationResultCard',
  props: {
  certification: {
    type: Object as PropType<any>,
    required: true,
  },
},
  setup(__props) {

const { decodeHTMLEncodedStr } = useFunctions();
const { showCreatedDate } = useDebugDateKey();

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "borrower-name",
            title: _unref(decodeHTMLEncodedStr)(__props.certification.borrowerFullName)
          }, _toDisplayString(_unref(decodeHTMLEncodedStr)(__props.certification.borrowerFullName) || "No Name"), 9, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(__props.certification.certificationStatusTypeDescription), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h5", {
            class: "icon icon-single-person",
            title: __props.certification.referenceId
          }, _toDisplayString(__props.certification.referenceId), 9, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", null, _toDisplayString(__props.certification.loanAmountFormatted), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h5", {
          class: "icon icon-hand-shake",
          title: __props.certification.lenderName
        }, _toDisplayString(__props.certification.lenderName), 9, _hoisted_13)
      ]),
      (_unref(showCreatedDate))
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(__props.certification.createdAtUtc), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})